export enum IconTypes {
    ARROW = 'arrow',
    DEFAULT = 'default'
}
